import { useState } from 'react';
import { useDeleteQuote } from '../../api/useDeleteQuote';

type Props = {
  groupId: string;
  quoteId: string;
};

export function useQuoteMenuAction(props: Props) {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const { mutateAsync } = useDeleteQuote();

  return {
    isEditOpen,
    isDeleteOpen,
    handleOpenEdit: () => setIsEditOpen(true),
    handleCloseEdit: () => setIsEditOpen(false),
    handleOpenDelete: () => setIsDeleteOpen(true),
    handleCloseDelete: () => setIsDeleteOpen(false),
    handleConfirmDelete: () => mutateAsync({ groupId: props.groupId, quoteId: props.quoteId }),
  };
}
